import React from "react";
import NewsList from "./List/NewsList";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "../../components/common/css/datatable.scss";
import "../../components/common/css/index.scss";

const News = () => {
    return (
        <div className="list">
            <Sidebar />
            <div className="listContainer">
                <Navbar />
                <NewsList />
            </div>
        </div>
    );
};

export default News;